import { presentAgreementTitle } from '@/lib/formatters/agreements';
import { useTenantConfig } from '@/contexts/TenantConfig';
import { useTenantPoliciesQuery } from '@/lib/graphql';
import classes from './Legal.module.css';
import Icon from '@/components/Icon';
import Link from 'next/link';
import SubSectionWrapper from '@/components/layouts/AppShell/PatientProfileDrawer/SubSectionWrapper/SubSectionWrapper';

interface LegalProps {
  onGoBack: () => void;
}

export const Legal = ({ onGoBack }: LegalProps) => {
  const { domain } = useTenantConfig();
  const { data: policiesData, loading } = useTenantPoliciesQuery({
    variables: { domain: domain },
  });

  return (
    <SubSectionWrapper title="Legal" onGoBack={onGoBack}>
      {!loading && (
        <ul className={classes.unorderedList}>
          {policiesData?.tenant?.policiesConfig?.map((policy) => (
            <li key={`legal.policyUrl.${policy.slug}`}>
              <Link
                className={classes.listItem}
                href={policy.url}
                target="_blank">
                {presentAgreementTitle(policy.slug)}
                <Icon name="feather/chevron-right" />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </SubSectionWrapper>
  );
};
